import PropTypes from 'prop-types';

import { LECTURE_CONTENT_TYPES } from '@classCreation/data/lectureContentTypes';

const LectureContentResourceType = PropTypes.shape({
  content_type: PropTypes.oneOf(Object.values(LECTURE_CONTENT_TYPES)),
  content: PropTypes.string,
});

export default LectureContentResourceType;
